import React from "react";

import styles from "./styles.module.scss";

export interface IProps {
  uri: string;
  title: string;
}

const ServiceHighlight: React.FC<IProps> = (props) => {
  return (
    <div className={styles.container}>
      <div className={styles.gradient}>
        <img className={styles.image} src={props.uri} alt="" />
        <h2>{props.title}</h2>
      </div>
    </div>
  );
};

export default ServiceHighlight;
